import React from 'react';
import 'scss/_loading.scss';

export default function AppLoading() {
  return (
    <div
      style={{
        position: 'fixed',
        backgroundColor: '#f4f6f9',
        width: '100%',
        height: '100%',
        zIndex: 100000,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <div className="lds-roller">
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    </div>
  );
}
